<template>
	<v-layout row wrap accent class="section-benefits" id="benefits">
		<v-flex xs12 class="container">
			<v-layout wrap>
				<v-flex xs12 secondary--text text-xs-center>
					<h2 class="section-benefits-title">Sé parte de nuestra red de bodegueros afiliados</h2>
				</v-flex>
				<v-flex xs12 white class="section-benefits-card">
					<v-layout row wrap info--text>
						<v-flex xs12 md6>
							<v-layout
								class="section-benefits-container"
								row wrap align-center
								v-for="benefit in benefitsLeft"
								:key="benefit.id"
							>
								<v-flex xs2 sm1 md2 lg1 secondary--text>
									<div class="section-benefits-number success">
										{{ benefit.number }}
									</div>
								</v-flex>
								<v-flex xs10 sm11 md10 lg11>
									<div class="section-benefits-text">
										{{ benefit.text }}
									</div>
								</v-flex>
							</v-layout>
						</v-flex>
						<v-flex xs12 md6 class="section-benefits-right">
							<v-layout
								row wrap
								v-for="benefit in benefitsRight"
								:key="benefit.id"
							>
								<v-flex xs2 sm1 md2 lg1 secondary--text>
									<div class="section-benefits-number success">
										{{ benefit.number }}
									</div>
								</v-flex>
								<v-flex xs10 sm11 md10 lg11>
									<div class="section-benefits-text">
										{{ benefit.text }}
										<a v-if="benefit.id === 7" :href="link" target="_blank">Aqui</a>
									</div>
									<v-layout
										row wrap class="section-benefits-item"
										v-for="(item, index) in benefit.list"
										:key="index"
									>
										<v-flex xs2 sm1 md2 lg1>
											<img
												src="/static/images/icons/icon-check.svg"
												alt="viñeta para beneficio"
												height="29"
											/>
										</v-flex>
										<v-flex xs10 sm11 md10 lg11 class="section-benefits-item-text">
											{{ item }}
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>

function data() {
	return {
		benefitsLeft: [
			{
				id: 1,
				number: 1,
				text: 'Tus clientes se descargarán tu APP de Google play.',
			},
			{
				id: 2,
				number: 2,
				text: 'Tendrás tu usuario y contraseña secreta para que puedas ingresar al administrador web.',
			},
			{
				id: 3,
				number: 3,
				text: 'Podrás realizar dos tipos de entrega: El recojo en tienda y la entrega de pedidos a domicilio (delivery).',
			},
			{
				id: 4,
				number: 4,
				text: 'Podrás administrar todo desde tu computadora o celular.',
			},
			{
				id: 5,
				number: 5,
				text: 'Podrás gestionar tus productos, cambiar precios, agregar un nuevo producto o modificarlo.',
			},
		],
		benefitsRight: [
			{
				id: 6,
				number: 6,
				text: 'El servicio de implementación incluye:',
				list: [
					'3 horas de soporte por voz.',
					'La carga de la base de datos de tus productos a la plataforma.',
					'Soporte por correo, ilimitado.',
				],
			},
			{
				id: 7,
				number: 7,
				text: 'Acceder a nuestra promoción desde',
			},
		],
	};
}

export default {
	name: 'section-benefits',
	data,
	props: {
		link: [String],
	},
};
</script>

<style lang="scss" scoped>
	.section-benefits {
		padding: 86px 2% 94px;

		@media (min-width: 360px) {
			padding: 86px 5% 94px;
		}

		@media (min-width: 768px) {
			padding: 86px 8% 94px;
		}

		@media (min-width: 1024px) {
			padding: 103px 10%;
		}

		&-card {
			border-radius: 18px;
			box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);
			padding: 46px 2% 53px;

			@media (min-width: 360px) {
				padding: 46px 5% 53px;
			}

			@media (min-width: 768px) {
				padding: 46px 10% 53px;
			}

			@media (min-width: 1024px) {
				padding: 85px 5% 68px;
			}
		}

		&-title {
			font-size: size(large);
			font-weight: weight(w900);
			line-height: normal;
			margin-bottom: 72px;

			@media (min-width: 1024px) {
				font-size: size(large30);
				margin-bottom: 44px;
				text-transform: uppercase;
			}
		}

		&-number {
			border-radius: 100%;
			font-size: size(medium18);
			height: 34px;
			line-height: 34px;
			text-align: center;
			width: 34px;
		}

		&-text {
			font-size: size(medium20);
			line-height: normal;
		}

		&-item {
			margin-bottom: 19px;
			margin-left: -19%;

			@media (min-width: 768px) {
				margin-bottom: 21px;
				margin-top: 19px;
				margin-left: -8.5%;
			}

			@media (min-width: 1024px) {
				align-items: center;
				margin-bottom: 21px;
				margin-left: 0px;
			}

			&-text {
				font-size: size(medium18);
				line-height: normal;
			}
		}

		&-container {
			margin-bottom: 21px;

			@media (min-width: 1024px) {
				margin-bottom: 25px;
			}
		}

		&-right {
			@media (min-width: 1280px) {
				padding-left: 5%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/section-benefits.vue